import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import VideoCreatorGradientLogo from '@wix/da-ds/pkg/Icons/VideoCreatorGradientLogo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { Url } from '@wix/da-url';
import { BiData, ClickCreateAiVideoBiEvent, BiContextProvidedValue } from '@wix/da-bi/pkg/events';

import s from './VideoCreatorBanner.scss';

interface Props {}

const VideoCreatorBanner: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <PlainButtonOrLink
      className={s['root']}
      href={Url.videoCreatorLink()}
      biData={BiData<ClickCreateAiVideoBiEvent>({
        evid: 952,
        sectionname: 'create_with_banner',
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    >
      <div className={s['logo-wrap']}>
        <VideoCreatorGradientLogo size={IconSize.LARGE} disableDefaultColors aria-hidden="true" />
        <Heading className={s['logo-title']}>{t('deviation.details.videoCreator.title')}</Heading>
      </div>
      <div className={s['body']}>
        <span className={s['description']}>{t('deviation.details.videoCreator.description')}</span>
        <span className={s['separator']} aria-hidden="true">
          {'|'}
        </span>
        <span className={s['gradient-text']}>
          {t('deviation.details.videoCreator.link.text')}
        </span>
      </div>
    </PlainButtonOrLink>
  );
};

VideoCreatorBanner.displayName = 'VideoCreatorBanner';
export default VideoCreatorBanner;
